"use strict";

var _interopRequireDefault = require("/Users/yinpeng/Sites/gitlab/layaair-pro-web/performance/node_modules/@babel/runtime/helpers/interopRequireDefault.js").default;

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("core-js/modules/es.object.to-string.js");

var _axios = _interopRequireDefault(require("axios"));

var _elementUi = require("element-ui");

var _store = _interopRequireDefault(require("@/store"));

var _auth = require("@/utils/auth");

// create an axios instance
var service = _axios.default.create({
  baseURL: process.env.VUE_APP_BASE_API // url = base url + request url
  // withCredentials: true, // send cookies when cross-domain requests
  // timeout: 5000 // request timeout

}); // request interceptor


service.interceptors.request.use(function (config) {
  // do something before request is sent
  // console.log(config, "请求参数")
  if (_store.default.getters.token) {
    // let each request carry token
    // ['X-Token'] is a custom headers key
    // please modify it according to the actual situation
    // config.headers['Authorization'] = getToken()
    config.params ? null : config.params = {}; // 设置token

    if (config.method == 'post') {
      // debugger
      if (config.data instanceof FormData) {
        config.headers['Content-Type'] = 'multipart/form-data';
        config.headers['Accept'] = 'application/json';
        config.data.append('access_token', (0, _auth.getToken)());
      }
    }

    config.params['access_token'] = (0, _auth.getToken)();
  } // 上传文件二进制流
  // if(config.url === '/cda/doctor/uploadUserAvatar') {
  //   config.timeout = 300000;
  //   config.headers['Content-Type'] = 'multipart/form-data'
  //   config.headers['Accept'] = 'application/json'
  // }
  // if(config.url === '/pmi/familymem/updateFamilyMemById' || config.url === '/cda/doctor/saveOrUpdateDoctor') {
  //   config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
  //   config.headers['Accept'] = 'application/x-www-form-urlencoded'
  // }


  return config;
}, function (error) {
  // do something with request error
  console.log(error); // for debug

  return Promise.reject(error);
}); // response interceptor

service.interceptors.response.use(
/**
   * If you want to get http information such as headers or status
   * Please return  response => response
  */

/**
   * Determine the request status by custom code
   * Here is just an example
   * You can also judge the status by HTTP Status Code
   */
function (response) {
  var headers = response.headers;

  if (headers['content-type'] === 'application/octet-stream;charset=utf-8') {
    return response.data;
  }

  var res = response.data;
  console.log(res, '~~~接口请求返回值~~~'); // if the custom code is not 20000, it is judged as an error.

  if (res.ret != 0) {
    (0, _elementUi.Message)({
      message: res.msg || '系统开了会儿小差，请稍后再试',
      type: 'error',
      duration: 3 * 1000
    }); // 3: 重新登陆

    if (res.ret == 3) {
      // to re-login
      _elementUi.MessageBox.confirm('权限过期，请重新登录！', '提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        showCancelButton: false,
        showClose: false,
        type: 'warning'
      }).then(function () {
        _store.default.dispatch('user/resetToken').then(function () {
          location.reload();
        });
      });
    }

    return Promise.reject(res.msg);
  } else {
    return response;
  }
}, function (error) {
  console.log(error); // for debug

  if (error && error.response) {
    if (error.response.status == 400) {
      (0, _elementUi.Message)({
        message: error.response.data.message,
        type: 'error',
        duration: 3 * 1000
      });
    } else if (error.response.status == 401) {
      _elementUi.MessageBox.confirm('权限过期，请重新登录！', '提示', {
        confirmButtonText: '重新登录',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(function () {
        _store.default.dispatch('user/resetToken').then(function () {
          location.reload();
        });
      });
    } else if (error.response.status >= 500) {
      (0, _elementUi.Message)({
        message: '服务器错误！',
        type: 'error',
        duration: 3 * 1000
      });
    } else {
      (0, _elementUi.Message)({
        message: '系统开了会儿小差，请稍后再试！',
        type: 'error',
        duration: 3 * 1000
      });
    }
  }

  return Promise.reject(error);
});
var _default = service;
exports.default = _default;